<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0004 11.8079C8.22539 11.8079 6.77539 10.3662 6.77539 8.58288C6.77539 6.79954 8.22539 5.36621 10.0004 5.36621C11.7754 5.36621 13.2254 6.80788 13.2254 8.59121C13.2254 10.3745 11.7754 11.8079 10.0004 11.8079ZM10.0004 6.61621C8.91706 6.61621 8.02539 7.49954 8.02539 8.59121C8.02539 9.68288 8.90872 10.5662 10.0004 10.5662C11.0921 10.5662 11.9754 9.68288 11.9754 8.59121C11.9754 7.49954 11.0837 6.61621 10.0004 6.61621Z"
      :fill="color"
    />
    <path
      d="M10.0004 18.967C8.76706 18.967 7.52539 18.5003 6.55872 17.5753C4.10039 15.2087 1.38372 11.4337 2.40872 6.94199C3.33372 2.86699 6.89206 1.04199 10.0004 1.04199C10.0004 1.04199 10.0004 1.04199 10.0087 1.04199C13.1171 1.04199 16.6754 2.86699 17.6004 6.95033C18.6171 11.442 15.9004 15.2087 13.4421 17.5753C12.4754 18.5003 11.2337 18.967 10.0004 18.967ZM10.0004 2.29199C7.57539 2.29199 4.45872 3.58366 3.63372 7.21699C2.73372 11.142 5.20039 14.5253 7.43372 16.667C8.87539 18.0587 11.1337 18.0587 12.5754 16.667C14.8004 14.5253 17.2671 11.142 16.3837 7.21699C15.5504 3.58366 12.4254 2.29199 10.0004 2.29199Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      default: "#292626",
      type: String,
    },
  },
};
</script>
